export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL || 'http://localhost:8080/api';

export const PAGINATION_DEFAULT_PAGE_SIZE = 20;

export const PAGINATION_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const APP_NAME = 'ALIS';

export const CSV_MAX_ROWS = 500;
export const CSV_MAX_FILE_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB

/**
 * Set once the "How It Works" experience has been opened (stamped by the hub
 * page). The pre-launch auto-invite dialog that read this was removed until
 * go-live; when the invite returns it can read this key to skip users who
 * already explored — or switch to a `.v2` key to re-invite everyone.
 */
export const HOW_IT_WORKS_SEEN_KEY = 'belab.howItWorks.seen.v1';
